<app-fordjupning-karta-base [layerConfig]="layerConfig$ | async" (mapClicked)="onMapClicked($event)">
    <app-fordjupning-karta-popup [isLoading]="isLoadingPopupData" [popupContent]="popupData$ | async">
        <ng-container *ngIf="(popupData$ | async)?.thumbsUp; else elseTemplate" popupIcon>
            <span class="abinicon-oskadad_tall_uppfyllt" role="img" aria-label="Målet är uppnått"></span>
        </ng-container>
        <ng-template #elseTemplate popupIcon>
            <span class="abinicon-oskadad_tall_ej_uppfyllt" role="img" aria-label="Målet är inte uppnått"></span>
        </ng-template>
    </app-fordjupning-karta-popup>
</app-fordjupning-karta-base>
<br />
<ui-figure-caption>
    <ui-figure-text ui-figure-text-bold>
        Skalan i kartan visar måluppfyllelse samt skadenivå. Gränserna är 85 % för Tolerabel skada, 70-85 % för Allvarlig skada, 50-70 % för Svår skada och
        mindre än 50 % för Mycket svår skada.
    </ui-figure-text>
</ui-figure-caption>
